// extracted by mini-css-extract-plugin
export var chevronIcon = "_sd-1";
export var edgeToggle = "_sd-0";